module.exports = __webpack_public_path__ + "static/media/for-sale-rafiki.1309c662.svg";